import React from "react";
import Layout from "../assets/Layout";
import UserLayout from "../assets/UserLayout";
import ServiceSessionDetailTable from "../components/Coach/ServiceSessionDetailTable";
import { Box } from "@mui/material";

const ServiceSessionDetails = () => {
    return (
        <>
            <Layout>
                <UserLayout userRole={"coach"}>
                    <Box sx={{mt:{md:8, xs:2}}}>
                        <ServiceSessionDetailTable />
                    </Box>
                </UserLayout>
            </Layout>
        </>
    )
}

export default ServiceSessionDetails;